import ApplicationDispatcher from '../../dispatcher/ApplicationDispatcher.js';
import NotificationConstants from './NotificationConstants.js';

export default {
    notify: function (notificaiton) {
        ApplicationDispatcher.handleViewAction({
            actionType: NotificationConstants.NOTIFY,
            data: notificaiton
        });
    },

    nextNotification: function (notificaiton) {
        ApplicationDispatcher.handleViewAction({
            actionType: NotificationConstants.NOTIFICATION_NEXT,
            data: null
        });
    },

    toast: function (type, message) {

    }
};
